import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['navigation', 'dropdownContainer', 'dropdownLink', 'dropdownMenu', 'languageContainer', 'languageMenu', 'languageLink'];

	initialize() {
		this.oldScrollValue = 0;
	}

	connect() {
		document.addEventListener('click', (e) => {
			this.closeDropdownsOnDocumentClick(e);
		});
	}

	toggleDropdown(e) {
		e.preventDefault();

		const dropdownContainer = e.currentTarget.closest('[data-navigation-desktop-target="dropdownContainer"]');

		if (dropdownContainer.hasAttribute('data-group-toggle')) {
			dropdownContainer.removeAttribute('data-group-toggle');
		} else {
			this.closeAllDropdowns();
			dropdownContainer.setAttribute('data-group-toggle', true);
		}
	}

	closeAllDropdowns() {
		this.dropdownContainerTargets.forEach((dropdownContainerTarget) => {
			dropdownContainerTarget.removeAttribute('data-group-toggle');
		});
	}

	closeDropdownsOnDocumentClick(e) {
		if (
			!this.dropdownMenuTargets.includes(e.target) &&
			!this.dropdownMenuTargets.includes(e.target.closest('[data-navigation-desktop-target="dropdownMenu"]')) &&
			!this.dropdownLinkTargets.includes(e.target) &&
			!this.dropdownLinkTargets.includes(e.target.closest('[data-navigation-desktop-target="dropdownLink"]'))
		) {
			this.closeAllDropdowns();
		}
	}
}
